module.exports = __webpack_public_path__ + "img/application2.ddab14c4.png";